import style from './assignEmp.module.scss';
import cn from 'classnames';
import SearchIcon from '@assets/images/Fireboard/Search';
import constant from '@components/common/globalization';
import PropTypes from 'prop-types';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const Header = props => {
  const { activeTab, onSearch, searchVal, onFilterChange } = props;

  return (
    <>
      <div className="my-3">
        <form className="position-relative">
          <input
            type="text"
            placeholder={FLABEL().ASSIGN_EMPLOYEE_SEARCH}
            value={searchVal}
            onChange={e => onSearch(e.target.value)}
            className={cn(style.searchInput, 'col-12 pl-3 pr-5')}
          />
          <div className={style.searchIcon}>
            <SearchIcon />
          </div>
        </form>
      </div>
      <div className={cn(style.buttonGroup)}>
        <button
          className={`${style.filterBtn} ${
            activeTab === constant.ALL ? style.active : ''
          }`}
          onClick={() => onFilterChange(constant.ALL)}
        >
          {FLABEL().ASSIGN_EMPLOYEE_ALL}
        </button>
        <button
          className={`${style.filterBtn} ${
            activeTab === constant.ASSIGNED ? style.active : ''
          }`}
          onClick={() => onFilterChange(constant.ASSIGNED)}
        >
          {FLABEL().ASSIGN_EMPLOYEE_ASSIGNED}
        </button>
        <button
          className={`${style.filterBtn} ${
            activeTab === constant.UNASSIGNED ? style.active : ''
          }`}
          onClick={() => onFilterChange(constant.UNASSIGNED)}
        >
          {FLABEL().ASSIGN_EMPLOYEE_UNASSIGNED}
        </button>
      </div>
    </>
  );
};

export default Header;

Header.propTypes = {
  activeTab: PropTypes.string,
  onSearch: PropTypes.func,
  searchVal: PropTypes.string,
  onFilterChange: PropTypes.func,
};

Header.defaultProps = {
  onFilterChange: () => {},
  onSearch: () => {},
};
